/**
 * This script manages the modal functionality for the "super-downloads" feature.
 * - It controls the opening and closing of a modal with dynamic iframe content.
 * - The modal loads video URLs dynamically and includes a loading spinner while the iframe is loading.
 * - The modal can be closed via the close button, backdrop, or Escape key.
 * - The iframe content is unloaded after closing to stop video playback.
 */

document.addEventListener('DOMContentLoaded', function () {

    const isInline = document.querySelector(".super-downloads__modal-iframe-wrapper--inline") !== null;
    const redirectsToPlayer = document.querySelector(".redirect-to-player") !== null;
    if (isInline || redirectsToPlayer) return;

    const modal = document.getElementById('superDownloadsModal'); 
    const modalIframe = document.getElementById('superDownloadsModalIframe');
    const closeModalBtn = document.getElementById('superDownloadsModalClose');
    const backdrop = document.getElementById('superDownloadsModalBackdrop');
    const spinner = document.getElementById('superDownloadsModalSpinner');
  
    // modal visibility class
    const VISIBLE_CLASS = 'super-downloads__modal--visible';
  
    /**
     * Show the spinner (indicates the iframe is loading)
     */
    function showSpinner() {
      spinner.setAttribute('aria-hidden', 'false');
    }
  
    /**
     * Hide the spinner (indicates the iframe has finished loading)
     */
    function hideSpinner() {
      spinner.setAttribute('aria-hidden', 'true');
    }
  
    /**
     * Opens the modal and loads the iframe URL
     * @param {string} iframeUrl - The URL to load in the iframe
     */
    function openModal(iframeUrl) {
      showSpinner();

      modalIframe.src = iframeUrl;
      modal.classList.add(VISIBLE_CLASS);
  
      // Once the iframe is loaded, hide the spinner
      modalIframe.onload = () => {
        hideSpinner();
      };
    }
  
    /**
     * Closes the modal
     */
    function closeModal() {
      modal.classList.remove(VISIBLE_CLASS);
      hideSpinner();
  
      // After a small delay, remove the iframe source to stop the video
      setTimeout(() => {
        modalIframe.src = ''; 
      }, 300); // The delay ensures the transition finishes before unloading
    }
  
    /**
     * Add click event listeners to all buttons with the class 'button--watch'
     * These buttons are expected to open the modal with the corresponding iframe URL
     */
    document.querySelectorAll('.button--watch').forEach(button => {
      button.addEventListener('click', function (event) {
        const iframeUrl = this.getAttribute('href');
        if (!this.hasAttribute('disabled')) {
          event.preventDefault();
          openModal(iframeUrl);
        }
      });
    });
  
    // Close the modal when the close button is clicked
    closeModalBtn.addEventListener('click', closeModal);
  
    // Close the modal when the backdrop is clicked
    backdrop.addEventListener('click', closeModal);
  
    // Close the modal when the 'Escape' key is pressed
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
});
